<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15 header">
        <el-button type="primary"
                    @click="$refs['companyForm'].show()"
                    size="small">添加公司
        </el-button>
      </div>
      <el-table ref="table"
                :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <template v-for="(attr, index) of companyFields">
          <el-table-column v-if="attr.prop === 'is_disabled'"
          prop="is_disabled"
          label="启用状态"
          min-width="80">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.is_disabled ? '#f56c6c' : '#67c23a' }">
              {{ scope.row.is_disabled ? '已禁用' : '启用中' }}
            </span>
          </template>
        </el-table-column>
          <el-table-column v-else :key="index" v-bind="attr"></el-table-column>
        </template>

        <el-table-column fixed="right"
                         label="操作"
                         width="160">
          <template slot-scope="scope">
            <button-gutter>
              <el-button type="primary"
                         @click="$refs['companyForm'].show(scope.row.id)"
                         size="mini"> 编辑
              </el-button>
              <el-button
                size="mini"
                :type="scope.row.is_disabled ? 'success' : 'danger'"
               @click="toggleEnable(scope.row)">{{scope.row.is_disabled ? '启用' : '禁用'}}</el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <company-form-dialog @submitted="onSearch" ref="companyForm" />
  </div>
</template>

<script>
import { searchRules } from '../finance-config.rules.js'
import financelConfigMixins from '../finance-config.mixins'
import dateTimePicker from '@core/mixins/dateTimePicker'
import CompanyFormDialog from '../components/CompanyFormDialog'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker, financelConfigMixins],
  components: { CompanyFormDialog },
  data () {
    return {
      showDialog: false,
      searchRules,
      search: {
        id: null,
        name: null,
      }
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('ourCompaniesLists', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.companyFields,
        keyName: 'prop',
        labelName: 'label'
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.companyFields,
        keyName: 'prop',
        labelName: 'label',
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    toggleEnable (row) {
      this.$confirm(row.is_disabled ? '是否确定启用' : '是否确定禁用', '提示', {type: 'warning'}).then(() => {
        request.common(row.is_disabled ? 'enableCompany' : 'disableCompany', {id: row.id}).then((res) => {
          this.$message.success('更新成功')
          this.onRefresh()
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/FinanceCompanyAccount.vue